export default __webpack_public_path__ + "main/assets/5-stars-500x116-8b0c1597.png";